module.exports = __webpack_public_path__ + "img/skills-list.56f58f21.png";